import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';

const defaultControlValue = {
  mode: 'delete',
  mutate: null,
  value: { id: null, projectProposal: { englishName: null, vietnameseName: null } },
};

const Confirm = forwardRef(({ refetch }, ref) => {
  // #region Data
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [projectProposalControl, setProjectProposalControl] = useState(defaultControlValue);
  const { mode, mutate, value } = projectProposalControl;
  // #endregion

  // #region Event
  useImperativeHandle(
    ref,
    () => ({
      open: (_projectProposalControl) => {
        setProjectProposalControl({ ..._projectProposalControl });
        setVisible(true);
      },
    }),
    []
  );

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('projectProposal.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => {
          setProjectProposalControl(defaultControlValue);
          setVisible(false);
        }}
        autoFocus
      />
      <Button
        label={t('projectProposal.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          if (!value.id) return;
          mutate(value.id, {
            onSuccess: () => {
              toast(TOAST.SUCCESS, t(`project.${mode}.success`));
              setProjectProposalControl(defaultControlValue);
              setVisible(false);
              refetch();
            },
            onError: (error) => {
              toast(TOAST.ERROR, mapError(t, error));
            },
          });
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <p className={`text-${mode === 'delete' ? 'red' : 'yellow'}-500`}>
          {t(`project.${mode}.title`)}
        </p>
      }
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => {
        setProjectProposalControl(defaultControlValue);
        setVisible(false);
      }}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg font-bold">
        {t('projectProposal.label')}:{' '}
        {t('lang') === 'vi'
          ? value?.projectProposal?.vietnameseName
          : value?.projectProposal?.englishName}
      </p>
      <p className="text-lg">{t(`project.${mode}.confirmationMessage`)}</p>
    </Dialog>
  );
});

export default Confirm;

Confirm.propTypes = {
  refetch: PropTypes.func.isRequired,
};
